import {Component, Input, SimpleChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {FieldConfig, FieldConfigOption, FieldConfigType} from 'src/app/model/field-config';
import {AbstractComponent} from '../abstract.component';

@Component({
  selector: 'app-field-config-value-input',
  templateUrl: './field-config-value-input.component.html',
  styleUrls: ['./field-config-value-input.component.scss']
})
export class FieldConfigValueInputComponent extends AbstractComponent {
  @Input() inputForm: FormGroup<any> | undefined;
  @Input() fieldKey: string | undefined;
  @Input() fieldConfig: FieldConfig | undefined;

  label: string = ""
  translatedLabels: string[] = [];
  options: Map<number, string> = new Map<number, string>();

  constructor(public translocoService: TranslocoService) {
    super();
  }

  ngOnInit() {
    this.initFields();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fieldConfig']?.currentValue !== changes['fieldConfig']?.previousValue) {
      this.initFields();
    }
  }

  initFields() {
    if (this.fieldConfig) {
      this.label = this.getLabel(this.fieldConfig);
      if (this.fieldConfig.fieldConfigTypeId === FieldConfigType.MULTISELECT) {
        this.options = this.getOptions();
      }
      if (this.fieldConfig.fieldConfigTypeId === FieldConfigType.SELECT) {
        this.translatedLabels = this.getTranslatedLabels();
      }
    }
  }

  getLabel(object: FieldConfig | FieldConfigOption): string {
    let label: string = object.name ?? "";
    switch (this.translocoService.getActiveLang()) {
      case "en":
        label = object.nameEng && object.nameEng.length > 0 ? object.nameEng : label;
        break;
      case "hr":
        label = object.name && object.name.length > 0 ? object.name : label;
        break;
      case "slo":
        label = object.nameSlo && object.nameSlo.length > 0 ? object.nameSlo : label;
        break;
      case "sr":
        label = object.nameSr && object.nameSr.length > 0 ? object.nameSr : label;
        break;
      case "bs":
        label = object.nameBs && object.nameBs.length > 0 ? object.nameBs : label;
        break;
      case "it":
        label = object.nameIta && object.nameIta.length > 0 ? object.nameIta : label;
        break;
      default:
        break;
    }
    return label;
  }

  getTranslatedLabels(): string[] {
    return this.fieldConfig?.options?.map((item: FieldConfigOption) => this.getLabel(item)) ?? [];
  }

  getOptions(): Map<number, string> {
    const optionsMap = new Map<number, string>();
    this.fieldConfig?.options?.map((option: FieldConfigOption) => {
      if (option.id) {
        optionsMap.set(option.id, this.getLabel(option))
      }
    });
    return optionsMap
  }

  protected readonly FieldConfigType = FieldConfigType;
}
